import { Box, Stack } from '@mui/material';
import FranchiseLoyaltyAPIDetailsDrawer from 'components/drawers/franchise-loyalty-api-details-drawer/franchise-loyalty-api-details-drawer.component';
import { useDrawer } from 'components/drawers/inc-drawer/inc-drawer.hooks';
import LoyaltyPerformanceHeader from 'components/loyalty-performance-header/loyalty-performance-header.component';
import SearchToolbar from 'components/search/search-toolbar/search-toolbar.component';
import {
  MultipleSearchQueryProvider,
  SearchParamsProvider,
} from 'components/search/search.context';
import {
  useSearchParams,
  useSearchQuery,
} from 'components/search/search.hooks';
import FranchiseActiveMembers from './franchise-active-members/franchise-active-members.component';
import {
  useFranchiseActiveMembersQuery,
  useFranchiseLoyaltySalesQuery,
  useFranchiseSummaryQuery,
} from 'api/reports-service/reports-service';
import JobsStatusGate from 'components/jobs-status-gate/jobs-status-gate.component';
import FranchiseLoyaltySales from './franchise-loyalty-sales/franchise-loyalty-sales.component';
import { useFranchiseLoyaltyOverviewSearchParams } from '../loyalty-performance-report.hooks';
import {
  LPComparisonDateParams,
  LPStoreParams,
  LoyaltyPerformanceParamsDiff,
} from 'api/reports-service/reports-service.types';
import FranchiseSummaryCards from './franchise-summary-cards/franchise-summary-cards.component';

const filteredSearchParams: LoyaltyPerformanceParamsDiff<
  LPComparisonDateParams & LPStoreParams
> = [
  'granularity',
  'count',
  'page',
  'offerIds',
  // 'offerstatus',
  'datatype',
  'offerdatatype',
  // 'campaignId',
  'sortBy',
  'sortDirection',
  'offertype',
];

const SearchParamsWrapper = () => {
  const searchParams = useSearchParams(
    useFranchiseLoyaltyOverviewSearchParams(),
  );
  return (
    <SearchParamsProvider value={searchParams}>
      <FranchiseLoyaltyOverview />
    </SearchParamsProvider>
  );
};

const FranchiseLoyaltyOverview = () => {
  const { open, close, isOpen } = useDrawer();
  const franchiseSummary = useSearchQuery(useFranchiseSummaryQuery, {
    filteredSearchParams,
  });
  const franchiseActiveMembers = useSearchQuery(
    useFranchiseActiveMembersQuery,
    { filteredSearchParams },
  );
  const franchiseLoyaltySales = useSearchQuery(useFranchiseLoyaltySalesQuery, {
    filteredSearchParams,
  });

  return (
    <Stack marginTop={2}>
      <MultipleSearchQueryProvider
        value={{
          queries: {
            franchiseSummary,
            franchiseActiveMembers,
            franchiseLoyaltySales,
          },
        }}
      >
        <SearchToolbar />
        <Stack>
          <LoyaltyPerformanceHeader open={open} />
        </Stack>
        <Box display="grid" gap={2}>
          <Box
            display="grid"
            gap={2}
            gridTemplateColumns={{
              xs: '1fr',
              sm: '2fr 2fr',
              lg: 'repeat(5, 1fr)',
            }}
          >
            <FranchiseSummaryCards />
          </Box>
          <Box
            display="grid"
            gridAutoRows={{ xs: 300, lg: 500 }}
            gridTemplateColumns={{ xs: '1fr', xl: '1fr 1fr' }}
            gap={2}
          >
            <FranchiseActiveMembers />
            <FranchiseLoyaltySales />
          </Box>
        </Box>
        <FranchiseLoyaltyAPIDetailsDrawer isOpen={isOpen} close={close} />
      </MultipleSearchQueryProvider>
    </Stack>
  );
};

export default function GatedPage() {
  return (
    <JobsStatusGate>
      <SearchParamsWrapper />
    </JobsStatusGate>
  );
}
